import { useCallback } from "react";

import { useDispatch, useSelector } from "react-redux";

import type { ILeadsSearchFiltersDto } from "app/pages/sales-intelligence/modules/leads-search-filters";
import { selectFiltersValue } from "app/pages/sales-intelligence/modules/leads-search-filters";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";
import { saveSearchModalToggledAction } from "app/pages/sales-intelligence/sub-modules/advanced-search/store/action-creators";
import type {
    NewSearchDto,
    QueryFiltersDto } from "app/pages/sales-intelligence/sub-modules/advanced-search/types/dto";
import type {
    SavedSearchDto,
} from "app/pages/sales-intelligence/sub-modules/advanced-search/types/dto";

import { useUpdateSavedSearchMutation } from "../mutations";
import { ESavedSearchActions } from "../types/enums";

type HookValue = {
    onSaveSearch: (action: ESavedSearchActions, savedSearchData?: SavedSearchDto) => void;
    onStartNewSearch: () => void;
};

export const useSavedSearchActions = (savedSearchId: string): HookValue => {
    const dispatch = useDispatch();

    const filtersValue: Partial<ILeadsSearchFiltersDto> = useSelector(selectFiltersValue);

    const updateMutation = useUpdateSavedSearchMutation();

    const onSaveSearch = useCallback(
        (action: ESavedSearchActions, savedSearchData?: SavedSearchDto) => {
            if (action === ESavedSearchActions.Save) {
                dispatch(saveSearchModalToggledAction({ isOpen: true }));
            } else {
                void updateMutation.mutate({
                    searchId: savedSearchId,
                    dto: {
                        ...(savedSearchData as NewSearchDto),
                        queryFilters: filtersValue as QueryFiltersDto,
                    },
                });
            }
        },
        [updateMutation, savedSearchId, filtersValue],
    );

    const onStartNewSearch = useCallback(() => {
        void siNavigator.goToAdvancedSearchPage({ reload: true });
    }, []);

    return {
        onSaveSearch,
        onStartNewSearch,
    };
};
